// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sa-1";
export var stateContainer = "_sa-0";